var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17924",
    "data-name": "Group 17924",
    xmlns: "http://www.w3.org/2000/svg",
    width: 342.095,
    height: 191.628,
    viewBox: "0 0 342.095 191.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M325.975,88.1V65.453H312.363V88.1h-16.12V53.07H284.423V26.889h-9.672V0h-20.06V26.889h-9.672V53.07H233.556V21.582h-6.448V5.661h-3.94V21.582H200.242v100.48H182.689V111.447H171.943v10.614H154.391V88.1H122.868V65.453H109.256V88.1h-.716v43.518H94.211V106.14H77.016v25.474H62.688V53.07h-11.1V26.889H10.746V53.07H0V191.406H342.1V88.1Z",
    transform: "translate(0)",
    fill: "#242b41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 14.948,
    height: 8.542,
    transform: "translate(6.762 62.45)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 14.948,
    height: 8.542,
    transform: "translate(40.736 62.45)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 14.948,
    height: 8.542,
    transform: "translate(6.762 79.416)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 14.948,
    height: 8.542,
    transform: "translate(40.736 79.416)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 14.948,
    height: 8.542,
    transform: "translate(6.762 96.382)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 14.948,
    height: 8.542,
    transform: "translate(40.736 96.382)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 14.948,
    height: 8.542,
    transform: "translate(6.762 113.348)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 14.948,
    height: 8.542,
    transform: "translate(40.736 113.348)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 14.948,
    height: 8.542,
    transform: "translate(6.762 130.314)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 14.948,
    height: 8.542,
    transform: "translate(40.736 130.314)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 14.948,
    height: 8.542,
    transform: "translate(6.762 147.28)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 14.948,
    height: 8.542,
    transform: "translate(40.736 147.28)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 14.948,
    height: 8.542,
    transform: "translate(6.762 164.13)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 14.948,
    height: 8.542,
    transform: "translate(40.736 164.131)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 34.879,
    height: 4.271,
    transform: "translate(68.342 142.913)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 34.879,
    height: 4.271,
    transform: "translate(68.342 149.41)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 34.879,
    height: 4.271,
    transform: "translate(68.342 155.716)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 34.879,
    height: 4.271,
    transform: "translate(160.024 145.079)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 34.879,
    height: 4.271,
    transform: "translate(160.024 151.575)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 34.879,
    height: 4.271,
    transform: "translate(160.024 157.894)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 34.879,
    height: 4.271,
    transform: "translate(68.342 162.251)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 34.879,
    height: 4.271,
    transform: "translate(68.342 168.787)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 34.879,
    height: 4.271,
    transform: "translate(68.342 175.322)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 9.609,
    height: 12.457,
    transform: "translate(116.263 98.21)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 9.609,
    height: 12.457,
    transform: "translate(137.384 98.21)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 9.609,
    height: 12.457,
    transform: "translate(116.263 118.429)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 9.609,
    height: 12.457,
    transform: "translate(137.384 118.429)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 9.609,
    height: 12.457,
    transform: "translate(116.263 138.649)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 9.609,
    height: 12.457,
    transform: "translate(137.384 138.649)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 9.609,
    height: 12.457,
    transform: "translate(116.263 158.741)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 9.609,
    height: 12.457,
    transform: "translate(137.384 158.741)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 12.813,
    height: 16.372,
    transform: "translate(200.402 29.703)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 12.813,
    height: 16.372,
    transform: "translate(200.402 54.173)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 12.813,
    height: 16.372,
    transform: "translate(200.402 78.009)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 12.813,
    height: 16.372,
    transform: "translate(200.402 101.845)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 12.813,
    height: 16.372,
    transform: "translate(200.402 125.681)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 12.813,
    height: 16.372,
    transform: "translate(200.402 149.351)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 47.691,
    height: 13.88,
    transform: "translate(241.551 64.275)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 47.691,
    height: 13.88,
    transform: "translate(241.729 94.607)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 47.691,
    height: 13.88,
    transform: "translate(241.908 124.939)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 47.691,
    height: 13.88,
    transform: "translate(242.085 155.129)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 6.406,
    height: 13.524,
    transform: "translate(10.677 35.026)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 16.016,
    height: 20.643,
    transform: "translate(326.079 98.26)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 16.016,
    height: 20.643,
    transform: "translate(326.079 128.605)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 16.016,
    height: 20.643,
    transform: "translate(326.079 158.871)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(220.301 118.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M155.539,584.026s-17.313,10.445,14.6,26.527c0,0,7.037-13.053-.743-23.7a10.481,10.481,0,0,0-13.6-2.98Z",
    transform: "translate(-150.851 -538.159)",
    fill: "#01a09b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M173.08,588.3s14.815,11.336,14.4,26.747",
    transform: "translate(-167.947 -542.653)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M234.654,504.024s-5.425-18.419,1.018-31.976a29.086,29.086,0,0,0,2.353-18.252,48.929,48.929,0,0,0-2.584-8.576",
    transform: "translate(-214.247 -431.036)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M234.992,391.471c0,2.258-4.088,8.8-4.088,8.8s-4.088-6.546-4.088-8.8a4.088,4.088,0,1,1,8.174,0Z",
    transform: "translate(-209.803 -387.289)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M265.615,441.085c-1.227,1.9-8.215,5.168-8.215,5.168s.128-7.716,1.355-9.612a4.088,4.088,0,0,1,6.861,4.442Z",
    transform: "translate(-233.621 -424.19)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M259,532.89c-2.016,1.016-9.7.314-9.7.314s4-6.6,6.021-7.613a4.088,4.088,0,1,1,3.681,7.3Z",
    transform: "translate(-227.308 -494.245)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M242.109,607.468c-1.814,1.341-9.509,1.948-9.509,1.948s2.832-7.178,4.646-8.521a4.088,4.088,0,1,1,4.862,6.573Z",
    transform: "translate(-214.304 -552.342)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M213.73,463.51c1.618,1.572,9.163,3.2,9.163,3.2s-1.847-7.492-3.466-9.067a4.088,4.088,0,1,0-5.7,5.863Z",
    transform: "translate(-198.59 -440.921)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M190.926,547.18c2.016,1.016,9.7.314,9.7.314s-4-6.6-6.021-7.613a4.088,4.088,0,1,0-3.682,7.3Z",
    transform: "translate(-180.095 -505.327)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M185.573,634.629c1.814,1.341,9.509,1.948,9.509,1.948s-2.832-7.18-4.649-8.521a4.088,4.088,0,1,0-4.862,6.573Z",
    transform: "translate(-176.388 -573.041)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M234.992,391.471c0,2.258-4.088,8.8-4.088,8.8s-4.088-6.546-4.088-8.8a4.088,4.088,0,1,1,8.174,0Z",
    transform: "translate(-209.803 -387.289)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M265.615,441.085c-1.227,1.9-8.215,5.168-8.215,5.168s.128-7.716,1.355-9.612a4.088,4.088,0,0,1,6.861,4.442Z",
    transform: "translate(-233.621 -424.19)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M259,532.89c-2.016,1.016-9.7.314-9.7.314s4-6.6,6.021-7.613a4.088,4.088,0,1,1,3.681,7.3Z",
    transform: "translate(-227.308 -494.245)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M242.109,607.468c-1.814,1.341-9.509,1.948-9.509,1.948s2.832-7.178,4.646-8.521a4.088,4.088,0,1,1,4.862,6.573Z",
    transform: "translate(-214.304 -552.342)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M213.73,463.51c1.618,1.572,9.163,3.2,9.163,3.2s-1.847-7.492-3.466-9.067a4.088,4.088,0,1,0-5.7,5.863Z",
    transform: "translate(-198.59 -440.921)",
    fill: "#5ec5c1",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M190.926,547.18c2.016,1.016,9.7.314,9.7.314s-4-6.6-6.021-7.613a4.088,4.088,0,1,0-3.682,7.3Z",
    transform: "translate(-180.095 -505.327)",
    fill: "#93d502",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M185.573,634.629c1.814,1.341,9.509,1.948,9.509,1.948s-2.832-7.18-4.649-8.521a4.088,4.088,0,1,0-4.862,6.573Z",
    transform: "translate(-176.388 -573.041)",
    opacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(299.721 93.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1005.42,502.109s-7.244-24.594,1.36-42.7a38.836,38.836,0,0,0,3.142-24.371,65.334,65.334,0,0,0-3.45-11.451",
    transform: "translate(-988.3 -404.513)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1007.823,371.245c0,3.016-5.459,11.745-5.459,11.745s-5.459-8.741-5.459-11.745a5.459,5.459,0,1,1,10.914,0Z",
    transform: "translate(-984.299 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1038.42,420.99c-1.638,2.531-10.97,6.9-10.97,6.9s.17-10.3,1.809-12.834a5.459,5.459,0,1,1,9.161,5.931Z",
    transform: "translate(-1005.875 -398.431)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1032.312,513.854c-2.693,1.357-12.952.42-12.952.42s5.347-8.809,8.039-10.165a5.458,5.458,0,1,1,4.916,9.747Z",
    transform: "translate(-1000.161 -462.249)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1015.356,588.311c-2.423,1.791-12.7,2.6-12.7,2.6s3.782-9.584,6.2-11.378a5.458,5.458,0,1,1,6.492,8.777Z",
    transform: "translate(-988.364 -514.699)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M984.438,444.448c2.161,2.1,12.235,4.275,12.235,4.275s-2.466-10-4.628-12.106a5.459,5.459,0,0,0-7.608,7.831Z",
    transform: "translate(-974.324 -414.291)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M962.071,528.293c2.693,1.357,12.952.42,12.952.42s-5.347-8.809-8.04-10.165a5.459,5.459,0,0,0-4.912,9.745Z",
    transform: "translate(-957.659 -472.403)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M956.187,615.471c2.423,1.791,12.7,2.6,12.7,2.6s-3.782-9.584-6.2-11.378a5.458,5.458,0,1,0-6.492,8.777Z",
    transform: "translate(-953.974 -533.715)",
    fill: "#017572"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(207.56 127.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M899.186,590.313s4.719-16.016-.886-27.811a25.3,25.3,0,0,1-2.046-15.873,42.561,42.561,0,0,1,2.246-7.449",
    transform: "translate(-887.573 -526.626)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M892.72,511.789c0,1.965,3.559,7.656,3.559,7.656s3.559-5.695,3.559-7.656a3.559,3.559,0,1,0-7.118,0Z",
    transform: "translate(-885.278 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M909.813,538.606c1.068,1.648,7.147,4.5,7.147,4.5s-.11-6.712-1.178-8.36a3.559,3.559,0,1,0-5.969,3.865Z",
    transform: "translate(-908.247 -524.002)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M906.622,588.943c1.755.883,8.439.274,8.439.274s-3.484-5.737-5.235-6.62a3.559,3.559,0,0,0-3.2,6.349Z",
    transform: "translate(-904.8 -555.442)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M897.126,628.963c1.58,1.167,8.271,1.694,8.271,1.694s-2.463-6.243-4.043-7.41a3.559,3.559,0,0,0-4.228,5.716Z",
    transform: "translate(-891.94 -580.387)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M892.771,551.229c-1.424,1.367-7.969,2.787-7.969,2.787s1.605-6.517,3.015-7.883a3.559,3.559,0,1,1,4.954,5.1Z",
    transform: "translate(-876.595 -531.678)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M881.039,596.633c-1.755.883-8.439.274-8.439.274s3.484-5.737,5.235-6.62a3.559,3.559,0,0,1,3.2,6.349Z",
    transform: "translate(-861.141 -560.339)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M878.248,643.534c-1.58,1.167-8.271,1.694-8.271,1.694s2.477-6.246,4.043-7.413a3.559,3.559,0,0,1,4.228,5.719Z",
    transform: "translate(-856.926 -589.759)",
    fill: "#017572"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M341.836,151.224h-2.449a1.715,1.715,0,1,0,0-3.427H319.553a1.715,1.715,0,0,0,0,3.427H322a1.715,1.715,0,1,0,0,3.427h-3.427a1.715,1.715,0,1,0,0,3.427h19.835a1.715,1.715,0,1,0,0-3.427h3.427a1.715,1.715,0,1,0,0-3.427Z",
    transform: "translate(-246.922 -134.255)",
    fill: "#ebfaff",
    opacity: 0.099
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M587.836,272.224h-2.449a1.715,1.715,0,1,0,0-3.427H565.553a1.715,1.715,0,0,0,0,3.427H568a1.715,1.715,0,1,0,0,3.427h-3.427a1.715,1.715,0,1,0,0,3.427h19.835a1.715,1.715,0,1,0,0-3.427h3.427a1.715,1.715,0,1,0,0-3.427Z",
    transform: "translate(-404.834 -211.377)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M1006.836,114.224h-2.449a1.715,1.715,0,1,0,0-3.427H984.553a1.715,1.715,0,0,0,0,3.427H987a1.715,1.715,0,1,0,0,3.427h-3.427a1.715,1.715,0,1,0,0,3.427h19.835a1.715,1.715,0,0,0,0-3.427h3.427a1.715,1.715,0,1,0,0-3.427Z",
    transform: "translate(-673.753 -110.423)",
    fill: "#ebfaff",
    opacity: 0.099
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M519.3,465.94c-.274.2-.423.31-.423.31A1.8,1.8,0,0,0,519.3,465.94Z",
    transform: "translate(-376.732 -337.422)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M520.234,466.88c-.274.2-.424.31-.424.31A1.806,1.806,0,0,0,520.234,466.88Z",
    transform: "translate(-377.329 -338.023)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M520.234,465.94l-.424.31A1.8,1.8,0,0,0,520.234,465.94Z",
    transform: "translate(-377.329 -337.422)",
    fill: "#ebfaff",
    opacity: 0.071
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(278.188 125.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46-2",
    "data-name": "Path 46",
    d: "M1006.112,476.677s4.9-16.628-.919-28.867a26.257,26.257,0,0,1-2.124-16.478,44.182,44.182,0,0,1,2.333-7.742",
    transform: "translate(-993.918 -410.692)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-2",
    "data-name": "Path 47",
    d: "M996.9,369.436c0,2.039,3.691,7.941,3.691,7.941s3.691-5.91,3.691-7.941a3.691,3.691,0,1,0-7.379,0Z",
    transform: "translate(-989.041 -365.66)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-2",
    "data-name": "Path 48",
    d: "M1028.094,418.223c1.108,1.711,7.417,4.665,7.417,4.665s-.115-6.966-1.223-8.677a3.691,3.691,0,1,0-6.194,4.01Z",
    transform: "translate(-1026.328 -402.971)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-2",
    "data-name": "Path 49",
    d: "M1021.391,510.508c1.82.917,8.757.284,8.757.284s-3.615-5.956-5.436-6.873a3.69,3.69,0,1,0-3.324,6.59Z",
    transform: "translate(-1019.359 -475.617)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-2",
    "data-name": "Path 50",
    d: "M1004.156,585.121c1.638,1.211,8.584,1.759,8.584,1.759s-2.557-6.48-4.195-7.693a3.691,3.691,0,1,0-4.389,5.934Z",
    transform: "translate(-998.636 -535.352)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-2",
    "data-name": "Path 51",
    d: "M991.056,441.411c-1.461,1.419-8.273,2.89-8.273,2.89s1.668-6.764,3.129-8.185a3.691,3.691,0,1,1,5.144,5.295Z",
    transform: "translate(-974.125 -421.022)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52-2",
    "data-name": "Path 52",
    d: "M967.948,524.967c-1.82.917-8.757.284-8.757.284s3.615-5.956,5.436-6.873a3.691,3.691,0,0,1,3.321,6.589Z",
    transform: "translate(-947.162 -487.179)",
    fill: "#5ec5c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M962.558,612.281c-1.638,1.211-8.584,1.759-8.584,1.759s2.557-6.48,4.195-7.693a3.691,3.691,0,1,1,4.389,5.934Z",
    transform: "translate(-940.285 -557.006)",
    fill: "#017572"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterRight);
export default __webpack_public_path__ + "static/media/footer-right.827109737df5f2bb4825f4d652a79bd1.svg";
export { ForwardRef as ReactComponent };